import { Team } from "@redotech/redo-model/team";
import { storageKeys } from "@redotech/web-util/storage";

export const DEVICE_AUTH_TOKEN_KEY_PREFIX = "redo.device_authentication_token";
export const DEVICE_REFRESH_TOKEN_KEY_PREFIX = "redo.device_refresh_token";
export const DEVICE_ID_KEY_PREFIX = "redo.device_id";

export const DEVICE_AUTHENTICATION_TOKEN_KEY = (teamId: string) =>
  `${DEVICE_AUTH_TOKEN_KEY_PREFIX}.${teamId}`;

export const DEVICE_REFRESH_TOKEN_KEY = (teamId: string) =>
  `${DEVICE_REFRESH_TOKEN_KEY_PREFIX}.${teamId}`;

export const DEVICE_ID_KEY = (teamId: string) =>
  `${DEVICE_ID_KEY_PREFIX}.${teamId}`;

export function teamAllowsDeviceAuthentication(team: Team) {
  return team.settings?.security?.methods?.deviceAuthAndPin === true;
}

export function getDeviceAuthTokenKey(): string | undefined {
  for (const key of storageKeys(localStorage)) {
    if (key.startsWith(`${DEVICE_AUTH_TOKEN_KEY_PREFIX}.`)) {
      return key;
    }
  }
  return undefined;
}

export function getDeviceRefreshTokenKey(): string | undefined {
  for (const key of storageKeys(localStorage)) {
    if (key.startsWith(`${DEVICE_REFRESH_TOKEN_KEY_PREFIX}.`)) {
      return key;
    }
  }
  return undefined;
}

export function getDeviceIdKey(): string | undefined {
  for (const key of storageKeys(localStorage)) {
    if (key.startsWith(`${DEVICE_ID_KEY_PREFIX}.`)) {
      return key;
    }
  }
  return undefined;
}
